import { render, staticRenderFns } from "./FxExchangeRateSetup.vue?vue&type=template&id=923d4806&scoped=true"
import script from "./FxExchangeRateSetup.vue?vue&type=script&lang=js"
export * from "./FxExchangeRateSetup.vue?vue&type=script&lang=js"
import style0 from "./FxExchangeRateSetup.vue?vue&type=style&index=0&id=923d4806&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923d4806",
  null
  
)

export default component.exports